import { useAppSelector } from '@/store';
import type { CloningProgress } from '@/store/slices/poc/cloneQueueSlice';

/**
 * Returns the cloning progress for a specific CID, or undefined if
 * that CID is not currently being cloned.
 *
 * Selects primitives/stable references directly from state so that
 * non-matching CIDs always return `undefined` (stable reference).
 * useAppSelector's default `===` comparison then skips re-renders
 * for every row except the one currently being cloned.
 */
export function useCloningProgress(cid: string): CloningProgress | undefined {
  return useAppSelector(state => {
    const { currentlyCloning, cloningProgress } = state.cloneQueue;
    if (currentlyCloning?.cid !== cid || cloningProgress === null) return undefined;
    return cloningProgress;
  });
}
